import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Estates, Estate } from '@/models/Estate.model';

// Inital state
const state: Estates = {
  estates: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Estates> = {
  estates: (state) => state.estates,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Estates> = {
  setEstates(state, { estates }) {
    state.estates = estates;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Estates, Mutations, Getters> = {
  setEstates({ commit }, payload) {
    commit('setEstates', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Estates, Getters, Mutations, Actions>('EstateModule');

export const EstatesModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
